'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M4 18h17v-6H4v6zM4 5v6h17V5H4z' });

var ViewStream = function ViewStream(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

ViewStream = (0, _pure2.default)(ViewStream);
ViewStream.muiName = 'SvgIcon';

exports.default = ViewStream;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/ViewStream.js
// module id = 2994
// module chunks = 0